<template>
  <div class="inline-flex h-[46px] w-[99px] items-start justify-start">
    <button
      type="button"
      class="inline-flex items-center gap-x-2 rounded-lg border border-transparent px-4 py-3 text-sm
        font-semibold text-white disabled:pointer-events-none disabled:opacity-50"
      :class="`bg-${themeColor}-600 hover:bg-${themeColor}-700`"
    >
      Bearbeiten
    </button>
  </div>
</template>
<script setup lang="ts">
  import { useThemeColor } from '@/composables/useThemeColor'
  import { computed } from 'vue'

  const themeColor = computed(() => useThemeColor().value)
</script>
